import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FooterCTA() {
  return <section className="py-14 px-4 relative overflow-hidden border-t border-white/5 bg-[#050505]" data-id="element-59">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#25D366]/10 rounded-t-full blur-[100px] -z-10 pointer-events-none" data-id="element-60" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-61">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-8" data-id="element-62">
          Tenés dos caminos...
        </h2>

        <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" data-id="element-63">
          Seguís siendo el esclavo del{' '}
          <span className="italic text-gray-500" data-id="element-64">"typing..."</span> perdiendo
          ventas y tiempo... o activás tu{' '}
          <strong className="text-[#25D366]" data-id="element-65">Vendedor de Hierro</strong> hoy
          mismo y empezás a escalar tu negocio en serio.
        </p>

        <motion.a href="https://www.ilumente.com/cart/52267256250690:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="group relative inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-black font-black text-xl md:text-2xl px-8 py-6 rounded-2xl transition-all shadow-[0_0_40px_rgba(37,211,102,0.3)] hover:shadow-[0_0_60px_rgba(37,211,102,0.5)] w-full sm:w-auto no-underline" data-id="element-66">
          SÍ, QUIERO MI CLON DE VENTAS CON IA
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-67" />
          <div className="absolute inset-0 rounded-2xl ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-68" />
        </motion.a>

        <p className="mt-8 text-gray-500 font-medium" data-id="element-69">
          🔒 Pago 100% Seguro • Acceso Inmediato
        </p>
      </div>
    </section>;
}